// extracted by mini-css-extract-plugin
export var acitonButtons = "_gi-0";
export var additionalIcon = "_gi-f";
export var block = "_gi-1";
export var blockContent = "_gi-7";
export var blockDescription = "_gi-8";
export var blockIcon = "_gi-9";
export var blockTitle = "_gi-6";
export var border = "_gi-a";
export var center = "_gi-l";
export var edge = "_gi-b";
export var edgeLabel = "_gi-c";
export var edgePath = "_gi-d";
export var error = "_gi-e";
export var flowchart = "_gi-g";
export var flowchartContent = "_gi-h";
export var highlighted = "_gi-3";
export var hover = "_gi-4";
export var icon = "_gi-i";
export var left = "_gi-m";
export var navButton = "_gi-j";
export var navButtons = "_gi-k";
export var right = "_gi-n";
export var selected = "_gi-2";
export var small = "_gi-5";